import React from "react";
import Button from "@mui/material/Button";
import { AddToCartWrapper } from "./Addtocart.style";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import styled from "styled-components";

const AddToCartCTA = (props) => {
  const {
    AddtoCartItem,
    ATCText = "",
    isDeliverable = true,
    checkPinCodeAvailable,
  } = props;

  const AddToCartButton = styled.div`
  
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:  41px;
  font-size: 1rem;
  font-family :Ancizar Sans, sans-serif;
  font-weight: 500;
  background-color:rgb(132, 213, 46);
  color: white;
  cursor: pointer;
  border-radius: 5px;


  `
  return (
    <AddToCartWrapper>
    {/*   <Button
        variant="contained"
        size="large"
        fullWidth
        color="ATC"
        disabled={!isDeliverable || !checkPinCodeAvailable}
        sx={{ color: "white", fontSize: "1rem", columnGap: "3%" }}
        onClick={AddtoCartItem}
      >
        <ShoppingCartOutlinedIcon />
        {ATCText}
      </Button> */}
      <AddToCartButton onClick={AddtoCartItem} enabled={isDeliverable && checkPinCodeAvailable}>

        <ShoppingCartOutlinedIcon />
        {ATCText}
      </AddToCartButton>
    </AddToCartWrapper>
  );
};

export default AddToCartCTA;
